import React, { useEffect, useState } from "react";
import NormalTable from "../../../components/common/Tables/NormalTable";
import { getAllVenueBySlug, getReport } from "../../../api";
import ExportToExcel from "../../../components/ExportToExcel/ExportToExcel";
import { PulseLoader } from 'react-spinners';
import FlatPickr from "react-flatpickr";
import FormattedDate from "../../../components/common/DateFormat/FormattedDate";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row
} from "reactstrap";
import { handleError } from "../../../utils/errorHandler";
import moment from "moment";
import { useNightMode } from "../../../contexts/NightModeContext";
import { isMobile } from "../../../utils/utils";
import CommonSelect from "../../../components/common/Select/CommonSelect";
import { Grid } from "@mui/material";
interface Booking {
  organizerRevenue: number;
  discountAmount: number;
  stripeRevenue: number;
  bookedBy: string;
  bookingStatus: string;
  totalTicketAmount: number;
  eventoxRevenue: number;
}



const UserEventRevenueReport = () => {
  const { isNightMode } = useNightMode();
  const [bookingStatus, setBookingStatus] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [book, setBookNo] = useState("");
  const [fullBookingList, setFullBookingList] = useState<any[]>([]);
  const [reportForExcel, setReportForExcel] = useState<any[]>([]);
  const [selectedVenue, setSelectedVenue] = useState<string>("");
  const [eventVenues, setEventVenues] = useState<any[]>([]);
  const [fromDate, setFromDate] = useState<Date>();
  const [toDate, setToDate] = useState<Date>();
  console.log("reportForExcel", reportForExcel);

  const [reports, setReports] = useState<{ title: string; iconClass: string; description: string | number }[]>([
    { title: "Organizer Revenue", iconClass: "fa-solid fa-wallet fa-2x bg-dark", description: 0 },
    { title: "Total Discount", iconClass: "fa-solid fa-circle-xmark fa-2x bg-dark", description: 0 },
    { title: "Total Stripe Fee", iconClass: "fa-solid fa-circle-check fa-2x bg-dark", description: 0 },
  ]);

  const [bookingList, setBookingList] = useState<any[]>([]);
  const [eventList, setEventList] = useState<any[]>([]);

  const getEventVenue = async () => {
    try {
      const eventData = localStorage.getItem("eventData");
      if (!eventData) return;
      const slugId = JSON.parse(eventData).slugId;
      const resp = await getAllVenueBySlug(slugId);
      const venueOptions = resp.map((item: any) => {
        return {
          value: item.venueId,
          label: item.venueName
        }
      })
      const allVenue = {
        value: "0",
        label: "All Venues"
      }
      setEventVenues([allVenue, ...venueOptions])
    } catch (error) {
      handleError(error)
    }
  }
  useEffect(() => {
    getEventVenue();
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const eventData = localStorage.getItem("eventData");
        if (eventData) {
          const eventSlug = JSON.parse(eventData).eventId;
          const venueId = localStorage.getItem("venueId");
          const response = await getReport(eventSlug);
          const activeBooking = response.filter((item: any) => item.bookingStatus === 'confirmed' && item.venueId === venueId);

          if (activeBooking) {
            const mainBooking = activeBooking.filter((item: any) => item.bookedBy === "0" && item.venueId === venueId);
            // setBookingStatus(mainBooking);
            setFullBookingList(mainBooking); 
            generateExportData(mainBooking);
            generateCount(mainBooking);

          }
        }
      } catch (error) {
        console.error("Error fetching organizer revenue:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);



  const generateCount = (data: any[]) => {

    const eventData = localStorage.getItem("eventData");
    if (!eventData) return;
    const { ticketFee, processingFee } = JSON.parse(eventData);
    let summaryData: any[] = [];
    let totalEventoxFee = 0;
    let totalStripeFee = 0;
    let totalTicketAmount = 0;
    let totalDiscountAmount = 0;
    let totalTicketSold = 0;
    let totalGrandTotal = 0;
    let totalSuccessBooking = 0;
    let totalOrganizerRevenue = 0;
    // if processingFee and ticketFee is 0 then fee collected from organizer else fee collected from user
    const feeCollectedFromOrganizer = processingFee === 0 && ticketFee === 0;
    data.forEach(item => {
      if (item.bookedBy === '0' && item.bookingStatus === 'confirmed') {

        let stripefee = 0;
        let eventoxRevenue = 0;
        let organizerRevenue = 0;

        const grandTotal = item.grandTotal;
        const ticketAmount = item.totalTicketAmount;
        const discountAmount = item.discountAmount ? item.discountAmount : 0;
        const ticketCount = item.totalTicketCount;
        // if (feeCollectedFromOrganizer) {
        //   stripefee = ((grandTotal / 100) * 2.7) + 0.30;
        //   const ticketFee = ticketCount * 0.5;
        //   const ourFee = ((grandTotal / 100) * 2.5) + (ticketFee);
        //   if (Number(ticketCount) === 1) {
        //     eventoxRevenue = 0;
        //   } else {
        //     eventoxRevenue = Number(ourFee) - Number(stripefee);
        //   }

        //   organizerRevenue = grandTotal - stripefee - eventoxRevenue - discountAmount;

        // } else {
          if (item.stripeRevenue === null) {
            stripefee = ((grandTotal / 100) * 2.7) + 0.30;
          } else {
            stripefee = item.stripeRevenue;
          }
          if (item.eventoxRevenue === null) {
            eventoxRevenue = grandTotal - stripefee - ticketAmount;
          } else {
            eventoxRevenue = item.eventoxRevenue;
          }
          if (item.organizerRevenue === null) {
            organizerRevenue = (ticketAmount - stripefee - eventoxRevenue - discountAmount);
          } else {
            organizerRevenue = item.organizerRevenue;
          }
        // }

        totalStripeFee += Number(stripefee);
        totalEventoxFee += Number(eventoxRevenue);
        totalTicketAmount += Number(ticketAmount);
        totalDiscountAmount += Number(discountAmount);
        totalTicketSold += item?.totalTicketCount;
        totalGrandTotal += Number(grandTotal);
        totalOrganizerRevenue += Number(organizerRevenue);
        totalSuccessBooking += 1;

        const totalFee = Number(stripefee || 0) + Number(eventoxRevenue || 0);
        summaryData.push({
          bookingId:  item.bookingId,
          userDetails: {
            name: item?.bookingObject?.primaryContactDetails?.firstName + ' ' + item?.bookingObject?.primaryContactDetails?.lastName,
            email: item?.bookingObject?.primaryContactDetails?.email,
            phone: item?.bookingObject?.primaryContactDetails?.phoneNo,
            venue: item?.bookingObject?.venueDetails?.venueName
          },
          ticketDetails: {
            ticketName: item?.TicketType?.ticketType,
            ticketPrice: item?.TicketType?.price,

          },
          ticketSold: item?.totalTicketCount,
          totalTicketAmount: item?.totalTicketAmount,
          discount: `$${discountAmount.toFixed(2)}`,
          stripeFee: `$${stripefee ? stripefee.toFixed(2) : 0}`,
          eventoxRevenue: `$${eventoxRevenue ? eventoxRevenue.toFixed(2) : 0}`,
          totalFee: `$${totalFee.toFixed(2)}`,
          organizerRevenue: `$${organizerRevenue ? organizerRevenue.toFixed(2) : 0}`,
          grandTotal: `$${grandTotal.toFixed(2)}`,
          createdAt: moment(item.createdAt).format('DD-MMM-YYYY HH:mm:ss'),
        })
      }
    })

    setBookingStatus(summaryData);
    if (data.length > 0) {
      const currency = data[0].currency || "$";
      const totalFee = totalStripeFee + totalEventoxFee;
      setReports([
        { title: "Organizer Revenue", iconClass: "fa-solid fa-wallet fa-2x bg-dark", description: `${currency} ${totalOrganizerRevenue.toFixed(2)}`, },
        { title: "Total Discount", iconClass: "fa-solid fa-circle-xmark fa-2x bg-dark", description: `${currency} ${totalDiscountAmount.toFixed(2)}`, },
        { title: "Total Fee", iconClass: "fa-solid fa-circle-check fa-2x bg-dark", description: `${currency} ${totalFee.toFixed(2)}`, }
      ]);
    }
  }


  const columns = [
    {
      label: "User Details", key: "userName",
      cellContent: (row: any) => {
        return (
          <div>
            <span>{row?.Contact?.firstName}</span><br />
            <span>{row?.Contact?.email}</span><br />
            <span>{row?.Contact?.phoneNo}</span><br />
            <span>{row?.Venue?.venueName}</span><br />
          </div>
        )
      },
    },
    {
      label: "Ticket Details", key: "ticketDetails",
      cellContent: (row: any) => <span>{row?.TicketType?.ticketType}</span>,
    },
    { label: "Ticket Sold", key: "totalTicketCount" },
    {
      label: "Total Ticket Amount", key: "totalTicketAmount",
      cellContent: (row: any) => <span>{row?.totalTicketAmount} {row?.currency }</span>,
    },
    { label: "Discount Amount", key: "discountAmount" },
    {
      label: "Processing Fee", key: "processingFee",
      cellContent: (row: any) => <span>{row?.processingFee} {row?.currency }</span>,
    },
    {
      label: "Organiser Revenue", key: "organizerRevenue",
      cellContent: (row: any) => <span>{row?.organizerRevenue} {row?.currency }</span>,
    },
    {
      label: "Grand Total", key: "grandTotal",
      cellContent: (row: any) => <span>{row?.grandTotal} {row?.currency }</span>,
    },

    { label: "Created At", key: "createdAt",
      cellContent: (row: any) => <FormattedDate dateString={row?.createdAt} />
     },
  ];
  useEffect(() => {
    const filtered = fullBookingList.filter((item: any) => {
      const name = item?.Contact?.firstName?.toLowerCase() || "";
       const bookingDate = moment(item?.createdAt);

      const isInDateRange =
        (!fromDate || bookingDate.isSameOrAfter(moment(fromDate).startOf("day"))) &&
        (!toDate || bookingDate.isSameOrBefore(moment(toDate).endOf("day")));
      return (
        name.startsWith(search.toLowerCase()) &&
        isInDateRange
      );
    });
    setBookingStatus(filtered);
  }, [search, fullBookingList, fromDate, toDate]);

  const onSelectedVenue = async (e: any) => {
    setIsLoading(true);
    try {
      const selectedVenue = e;
      const eventData = localStorage.getItem("eventData");
      if (!eventData) return;
      const eventSlug = JSON.parse(eventData).eventId;
      const response = await getReport(eventSlug);
      const activeBooking = response.filter((item: any) => item.bookingStatus === 'confirmed');

      if (selectedVenue !== "0") {
        const mainBooking = activeBooking.filter((item: any) => item.bookedBy === "0" && item.venueId === selectedVenue);
        // setBookingStatus(mainBooking);
        // setFullBookingList(mainBooking);
        generateExportData(mainBooking);
        generateCount(mainBooking);
      } else {
        const mainBooking = activeBooking.filter((item: any) => item.bookedBy === "0");
        // setBookingStatus(mainBooking);
        // setFullBookingList(mainBooking);
        generateExportData(mainBooking);
        generateCount(mainBooking);
      }
      setSelectedVenue(selectedVenue);
    } catch (error) {
      handleError(error);
    } finally {
      setIsLoading(false);
    }
  }
  const generateExportData = (data: any[]) => {

    let reportExport: any[] = [];
    data.forEach((item: any) => {
      const stripe = item.stripeRevenue;
      const eventox = item.eventoxRevenue;
      const totalFee = Number(stripe) + Number(eventox);
      const obj = {
        userName: item?.Contact?.firstName || "",
        email: item?.Contact?.email || "",
        phoneNo: item?.Contact?.phoneNo || "",
        ticketType: item?.TicketType?.ticketType || "",
        totalTicketCount: item?.totalTicketCount || "",
        ticketAmount: item?.totalTicketAmount || "",
        discountAmount: item?.discountAmount || "",
        fee: totalFee,
        grandTotal: item?.grandTotal || "",
        createdAt: item?.createdAt || ""
      }
      reportExport.push(obj);
    });
    setReportForExcel(reportExport);
  }

  return (
    <div className="dashboard-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="d-main-title">
              <h3>
                <i className="mx-2">
                  <i className="fa-solid fa-chart-simple "></i>
                </i>
                Revenue Report
              </h3>
            </div>
          </div>
          <div className="col-md-12">
            <div className="main-card mt-5">
              <div className="dashboard-wrap-content p-2">
                <div className=" flex-wrap align-items-center">
                  <div className="dashboard-date-wrap mt-4">
                    {isMobile() && (
                      <div className="form-group">


                        <div className="search-container position-relative d-flex flex-column flex-md-row align-items-center gap-3 p-2">
                          {/* <div className="search-group position-relative w-100 mb-2 mb-md-0">
                          
                            <CommonSelect
                              options={eventVenues}
                              value={selectedVenue}
                              onChange={(e) => onSelectedVenue(e.target.value)}
                              label="Event Venue"
                            />
                            <i className="uil uil-search position-absolute start-0 top-50 translate-middle-y ms-2"></i>
                          </div> */}
                          <div className="search-group position-relative e-w-full mb-2 mb-md-0">
                            <input
                              className="form-control h_50 ps-4 e-w-full"
                              type="text"
                              placeholder="Search by User Details"
                              value={search}
                              onChange={(e) => setSearch(e.target.value)}
                            />
                            <i className="uil uil-search position-absolute start-0 top-50 translate-middle-y ms-2"></i>
                          </div>
                           <div className=" search-group position-relative e-w-full mb-2 mb-md-0">
                          <div className=" search-group position-relative e-w-full mb-2 mb-md-0">
                          <label>From Date:</label>
                          <FlatPickr
                          className="form-control"
                          value={fromDate}
                          onChange={([date]) => setFromDate(date)} 
                          options={{
                            dateFormat: "Y-m-d"
                          }}
                          placeholder="Select a date"
                        />
                        </div>
                        <div className="search-group position-relative e-w-full mb-2 mb-md-0">
                          <label>To Date:</label>
                          <FlatPickr
                            className="form-control"
                            value={toDate}
                            onChange={([date]) => setToDate(date)} 
                            options={{
                              dateFormat: "Y-m-d"
                            }}
                            placeholder="Select a date"
                          />
                        </div>
                        </div>
                          <div className="export-button position-relative w-100">
                            <ExportToExcel
                              data={reportForExcel}
                              fileName="Revenue_Report"
                            />
                          </div>
                          {/* <div className="search-group position-relative w-50 mb-2 mb-md-0">
                         <input
                           className="form-control h_40 ps-4"
                           type="text"
                           placeholder="Search by User Details"
                           value={search}
                           onChange={(e) => setSearch(e.target.value)}
                         />
                         <i className="uil uil-search position-absolute start-0 top-50 translate-middle-y ms-2"></i>
                       </div>  */}
                        </div>
                        <div className="relative-input position-relative"></div>
                      </div>
                    )}

                    <Container fluid>
                      <Row className="mb-3">
                        <Col xl="15">
                          <Grid container spacing={2}>
                            {(reports || [])?.map((report, key) => (
                              <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={"col" + key}>
                                <Card className={`mini-stats-wid ${isNightMode ? 'bg-dark text-white' : 'bg-light text-black'} mb-1`}>
                                  <CardBody>
                                    <div className="d-flex">
                                      <div className="flex-grow-1">
                                        <p className="fw-medium">{report.title}</p>
                                        <h4 className="mb-0">{report.description}</h4>
                                      </div>
                                      <div className="avatar-sm rounded-circle align-self-center mini-stat-icon">
                                        <span className="avatar-title rounded-circle">
                                          <i className={"bx " + report.iconClass + " font-size-24"}></i>
                                        </span>
                                      </div>
                                    </div>
                                  </CardBody>
                                </Card>
                              </Grid>
                            ))}
                          </Grid>
                        </Col>
                      </Row>
                    </Container>
                    {!isMobile() && (
                      <div className="form-group">


                        <div className="search-container position-relative d-flex flex-column flex-md-row align-items-center gap-3 p-2">
                          {/* <div className="search-group position-relative w-100 mb-2 mb-md-0">
                            
                            <CommonSelect
                              options={eventVenues}
                              value={selectedVenue}
                              onChange={(e) => onSelectedVenue(e.target.value)}
                              label="Event Venue"
                            />
                            <i className="uil uil-search position-absolute start-0 top-50 translate-middle-y ms-2"></i>
                          </div> */}
                          <div className="search-group position-relative w-50 mb-2 mb-md-0">
                            <input
                              className="form-control h_40 ps-4"
                              type="text"
                              placeholder="Search by User Details"
                              value={search}
                              onChange={(e) => setSearch(e.target.value)}
                            />
                            <i className="uil uil-search position-absolute start-0 top-50 translate-middle-y ms-2"></i>
                          </div>
                           <div className=" search-group position-relative e-w-full mb-2 mb-md-0">
                          <div className=" search-group position-relative e-w-full mb-2 mb-md-0">
                          <label>From Date:</label>
                          <FlatPickr
                            className="form-control"
                            value={fromDate}
                            onChange={([date]) => setFromDate(date)} 
                            options={{
                              dateFormat: "Y-m-d"
                            }}
                            placeholder="Select a date"
                          />
                        </div>
                        <div className="search-group position-relative e-w-full mb-2 mb-md-0">
                          <label>To Date:</label>
                          <FlatPickr
                            className="form-control"
                            value={toDate}
                            onChange={([date]) => setToDate(date)} 
                            options={{
                              dateFormat: "Y-m-d"
                            }}
                            placeholder="Select a date"
                          />  
                        </div>
                        </div>
                          <div className="export-button position-relative w-100">
                            <ExportToExcel
                              data={reportForExcel}
                              fileName="Revenue_Report"
                            />
                          </div>
                          {/* <div className="search-group position-relative w-50 mb-2 mb-md-0">
                          <input
                            className="form-control h_40 ps-4"
                            type="text"
                            placeholder="Search by User Details"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                          />
                          <i className="uil uil-search position-absolute start-0 top-50 translate-middle-y ms-2"></i>
                        </div>  */}
                        </div>
                        <div className="relative-input position-relative"></div>
                      </div>
                    )}
                  </div>
                  <div className="rs ms-auto mt-4 mt_r4"></div>
                </div>
              </div>
            </div>

            {isLoading ? (
              <div className="d-flex justify-content-center py-4">
                <PulseLoader color="#ffffff" size={9} speedMultiplier={1} />
              </div>
            ) : (
              <div className="event-list">
                <div className="tab-content">
                  <div className="tab-pane fade show active" id="orders-tab" role="tabpanel">
                    <NormalTable columns={columns} data={bookingStatus} getRowId={(row: any) => row.bookingId} />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserEventRevenueReport;
